// extracted by mini-css-extract-plugin
module.exports = {"add-to-cart-button":"AddToCartButton_add-to-cart-button__h25aX","add-to-cart-button--quick-cart":"AddToCartButton_add-to-cart-button--quick-cart__8MfG0"};